import React from "react";

const SupportTicketStatusBadge = ({ status }) => {
  const getStatusStyle = (status) => {
    const statusMap = {
      OPEN: { bg: "bg-success", text: "Open" },
      IN_PROGRESS: { bg: "bg-primary", text: "In Progress" },
      RESOLVED: { bg: "bg-info", text: "Resolved" },
      CLOSED: { bg: "bg-secondary", text: "Closed" },
      PENDING_INFO: { bg: "bg-warning", text: "Pending Info" },
      HIGH: { bg: "bg-danger", text: "High" },
      MEDIUM: { bg: "bg-warning", text: "Medium" },
      LOW: { bg: "bg-success", text: "Low" },
      CRITICAL: { bg: "bg-danger", text: "Critical" },
    };
    
    return statusMap[status] || { bg: "bg-secondary", text: status };
  };

  const statusStyle = getStatusStyle(status);
  
  return (
    <span className={`badge ${statusStyle.bg}`}>
      {statusStyle.text}
    </span>
  );
};

export default SupportTicketStatusBadge;